var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookshelfIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6177 8.79371e-08C3.78725 3.93708e-08 4.73535 0.948103 4.73535 2.11765L4.73535 29.8824C4.73535 31.0519 3.78725 32 2.61771 32C1.44816 32 0.500059 31.0519 0.500059 29.8824L0.500058 2.11765C0.500058 0.948103 1.44816 1.36503e-07 2.6177 8.79371e-08Z",
    fill: "#007E73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0386 8.79371e-08C12.2081 3.93708e-08 13.1563 0.948103 13.1563 2.11765L13.1563 29.8824C13.1563 31.0519 12.2081 32 11.0386 32C9.86906 32 8.92096 31.0519 8.92096 29.8824L8.92096 2.11765C8.92096 0.948103 9.86906 1.36503e-07 11.0386 8.79371e-08Z",
    fill: "#007E73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4595 8.79371e-08C20.629 3.93708e-08 21.5771 0.948103 21.5771 2.11765L21.5771 29.8824C21.5771 31.0519 20.629 32 19.4595 32C18.29 32 17.3419 31.0519 17.3419 29.8824L17.3419 2.11765C17.3419 0.948103 18.29 1.36503e-07 19.4595 8.79371e-08Z",
    fill: "#007E73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1223 2.64534C27.251 2.33909 28.439 2.99878 28.7757 4.1188L35.9138 27.8622C36.2505 28.9823 35.6084 30.1385 34.4797 30.4447C33.351 30.751 32.163 30.0913 31.8263 28.9713L24.6882 5.22784C24.3515 4.10781 24.9935 2.95159 26.1223 2.64534Z",
    fill: "#007E73"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookshelfIcon);
export default __webpack_public_path__ + "static/media/bookshelf-icon.fb49ed41aad8c6191c7928102d94bf8a.svg";
export { ForwardRef as ReactComponent };